import React, { Component, useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import ImageOnly from './ArticleRendering/ImageOnly'
import TextAboveImage from './ArticleRendering/TextAboveImage';
import TextBelowImage from './ArticleRendering/TextBelowImage';
import TextLeftImage from './ArticleRendering/TextLeftImage';
import TextRightImage from './ArticleRendering/TextRightImage';
import TextOnly from './ArticleRendering/TextOnly';
// import SearchField from './ArticleRendering/SearchField';
// import Accordion from './ArticleRendering/Accordion';
import TextOverImage from './ArticleRendering/TextOverImage';
import LinkOnly from './ArticleRendering/LinkOnly';
import Accordian from './ArticleRendering/Accordion';
import ClientContainer from './ClientSection/ClientContainer';
import './ArticleRendering/Accordion.css';
import HtmlRawContainerArticle from './HtmlRawContainerArticle';
import IframeContainerArticle from './IframeContainerArticle';
import FormStackContainer from './FormStackContainer';

function renderSwitch(renderType, articleObj, containerObjectAttr, containerObject) {
  switch (renderType) {
    //   case 'Accordion':
    //     return <Accordion articleObj={articleObj}></Accordion>
    case 'ImageOnly':
      return <ImageOnly articleObj={articleObj} containerObjectAttr={containerObjectAttr}></ImageOnly>
    case 'TextAboveImage':
      return <TextAboveImage articleObj={articleObj} containerObjectAttr={containerObjectAttr}></TextAboveImage>
    case 'TextBelowImage':
      return <TextBelowImage articleObj={articleObj} containerObjectAttr={containerObjectAttr}></TextBelowImage>
    case 'TextOverImage':
      return <TextOverImage articleObj={articleObj} containerObjectAttr={containerObjectAttr}></TextOverImage>
    case 'TextRightImage':
      return <TextRightImage articleObj={articleObj} containerObjectAttr={containerObjectAttr}></TextRightImage>
    case 'TextLeftImage':
      return <TextLeftImage articleObj={articleObj} containerObjectAttr={containerObjectAttr}></TextLeftImage>
    case 'LinkOnly':
      return <LinkOnly articleObj={articleObj} containerObjectAttr={containerObjectAttr}></LinkOnly>
    case 'Accordion':
      return <Accordian articleObj={articleObj} containerObjectAttr={containerObjectAttr}></Accordian>
    case 'ClientPage':
      return <ClientContainer articleObj={articleObj} containerObjectAttr={containerObjectAttr}></ClientContainer>
    case 'rawHtml':
      return <HtmlRawContainerArticle articleObj={articleObj} containerObjectAttr={containerObjectAttr} containerObject={containerObject}></HtmlRawContainerArticle>
    case 'iframe':
      return <IframeContainerArticle articleObj={articleObj} containerObjectAttr={containerObjectAttr}></IframeContainerArticle>
    case 'formStack':
      return <FormStackContainer articleObj={articleObj} containerObjectAttr={containerObjectAttr}></FormStackContainer>
    default:
      return <TextOnly articleObj={articleObj} containerObjectAttr={containerObjectAttr}></TextOnly>;
  }
}

function Article(props) {
  useEffect(() => {
    var hash = window.location.hash;
    if (hash) {
      var element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

  }, [])

  var articleObj = props.articleObj
  var renderType = articleObj.attributes.renderType
  var containerObjectAttr = props?.containerObject && props?.containerObject?.attributes
  var containerObject = props?.containerObject ? props?.containerObject :''
  return (
    renderSwitch(renderType, articleObj, containerObjectAttr, containerObject)
  )
}

export default Article
